import { useTranslation } from '@shared/utils/i18n';
import { Box, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useCalculateDebt } from '@features/osi/correction/calculateDebt/hooks/useCalculateDebt';

export const CalculateDebt: React.FC = observer(() => {
  const { t } = useTranslation();
  const { isPending, initialDebtText, resultDebtText } = useCalculateDebt();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '5px', marginBlockStart: '10px' }}>
      {isPending ? (
        <Typography>{`${t('common:loading')}...`}</Typography>
      ) : (
        <>
          <Typography color={'error'} variant={'subtitle1'}>
            {initialDebtText}
          </Typography>
          <Typography color={'error'} variant={'subtitle1'}>
            {resultDebtText}
          </Typography>
          <Typography sx={{ marginBlockStart: '10px' }} variant={'caption'}>
            {t('payments:description')}
          </Typography>
        </>
      )}
    </Box>
  );
});
